export const IntlNubmerFormatter = (number: number) => {
  //if (number === 0) return "0";
  return Intl.NumberFormat("No-no").format(number);
};
export const removeWhiteSpaces = (str: string) => {
  return Number(str.replace(/\s/g, ""));
};
export const formatStringToNumber = (string: string) => {
  return Number(string.replace(/[^0-9.-]+/g, ""));
};
export const formatZeroToEmpty = (number: number) => {
  if (number === 0) {
    return "";
  }
  return number;
};

export const mapObjectToInt = (obj: any) =>
  Object.assign(
    {},
    ...Object.entries(obj).map(([k, v]) => ({
      [k]: formatStringToNumber(v as string),
    }))
  );

export const mapObjectFieldsToInt = (integerValues: any) => {
  Object.keys(integerValues).forEach((key) => {
    //@ts-ignore
    integerValues[key] = formatStringToNumber(integerValues[key] as string);
  });
};
